import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

export class AppMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {

        let key = params.key;

        if(params && params.key) {
            const splittedKey: string [] = params.key.split('.');
            if(splittedKey[0].localeCompare('AUTHORIZATION_TREE') === 0 || splittedKey[0].localeCompare('DEPLOYMENT') === 0) {
                splittedKey.shift();
                key = splittedKey.join('.')
            }
        }

        return key;
    }
}
